
import { getSdkRequestToken } from '@/microfrontends/monitor-mfe/sdk/sdk-auth'

export function getWebsocketUrl () {
  const token: string = getSdkRequestToken() || ''
  return import.meta.env.VITE_APP_WEBSOCKET_URL + '?token=' + encodeURI(token)
}
